module.exports = __webpack_public_path__ + "static/contact-5fe4147d9536f282fe4a4ae6ddfa3a7e.png";